<template>
    <div class="page">
        <v-container>
        <v-card class="bordered surface-card rounded px-2">
            <v-card-title class="mb-2">Security Settings</v-card-title>
            <v-card-text>
                <div class="d-flex align-center mb-4">
                    <v-icon size="18" color="text" class="me-2">mdi-lock-outline</v-icon>
                    <span class="text--text font-weight-medium">Change Password</span>
                </div>
                <v-text-field flat filled hide-details label="New Password" :disabled="editing" type="password" :loading="editing" v-model="password"></v-text-field>
                <v-text-field flat filled hide-details class="mt-5" label="Confirm Password" :disabled="editing" type="password" :loading="editing" v-model="confirmPassword"></v-text-field>
                <div class="d-flex justify-end mt-4">
                    <v-btn large class="px-3" color="primary darken-1" :loading="editing" :disabled="editing" text @click="changePassword">confirm</v-btn>
                </div>
            </v-card-text>
            
        </v-card>
            
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Home",
    components: {
        
    },
    data(){
        return {
            loading: false,

            password: '',
            confirmPassword: '',
            editing: false,
        }
    },
    computed: {
        
        ...GlobalComputed
    },
    watch: {
        
    },
    methods: {
        
        changePassword(){
            this.editing = true;
            let password = this.password,
                confirm = this.confirmPassword;
            if (password){
                if(password === confirm){
                    this.$store.dispatch('changePassword', {password}).then(()=>{
                        this.showMsg('Password hase been changed successfully', 'success');
                        this.editing = false;
                        this.password = '';
                        this.confirmPassword = '';

                    }).catch((error)=>{
                        this.showMsg('Error occurred during preforming your action');
                        this.editing = false;
                        if (error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);

                        }else{
                            this.showMsg('Error occurred during creating your account');
                        }
                    })

                }else{
                    this.showMsg('Passwords do not match');
                    this.editing = false;
                }

            }else{
                this.showMsg('Fill required inputs');
                this.editing = false;
            }
        },
        ...GlobalMethods
    },
    mounted(){
        
    }
};
</script>
